<template>
  <div class="flow-block">
    <h4 class="flow-title">Acompanhando o envio</h4>
    <p class="flow-subtitle">
      Estamos criando as categorias nas dashes. Você pode fechar essa tela quando quiser, o andamento continua no histórico.
      <span v-if="isAutoRefreshing" class="auto-refresh-hint">Atualização automática ativa.</span>
    </p>

    <div class="batch-detail-panel mt-3">
      <div class="batch-detail-header">
        <div class="batch-detail-title-wrap">
          <h4 class="mb-1 batch-detail-title">{{ batch.name }}</h4>
          <p class="mb-0 batch-detail-subtitle">
            Categorias: {{ (batch.items || []).length }} · Criado em: {{ batch.created_at || '-' }}
          </p>
        </div>
        <vs-chip :color="statusColor(batch.status)">{{ humanStatus(batch.status) }}</vs-chip>
      </div>

      <div class="batch-counters">
        <div class="counter">
          <span class="counter-label">Total</span>
          <span class="counter-value">{{ batch.total_tenants || 0 }}</span>
        </div>
        <div class="counter">
          <span class="counter-label">Concluídas</span>
          <span class="counter-value ok">{{ batch.success_tenants || 0 }}</span>
        </div>
        <div class="counter">
          <span class="counter-label">Falhas</span>
          <span class="counter-value error">{{ batch.failed_tenants || 0 }}</span>
        </div>
        <div class="counter">
          <span class="counter-label">Em andamento</span>
          <span class="counter-value">{{ pendingItemsCount(batch) }}</span>
        </div>
      </div>

      <vs-table :data="batch.items || []" max-items="20" pagination class="mt-3">
        <template slot="thead">
          <vs-th>Dash</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Categoria criada</vs-th>
          <vs-th>Erro</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr v-for="row in data" :key="row.id">
              <vs-td>{{ row.tenant_name }}</vs-td>
              <vs-td><vs-chip :color="statusColor(row.status)">{{ humanStatus(row.status) }}</vs-chip></vs-td>
              <vs-td>{{ (row.resolved_ids && row.resolved_ids.group_name) || '-' }}</vs-td>
              <vs-td>
                <span v-if="row.error_message" class="text-danger">{{ shortError(row.error_message) }}</span>
                <span v-else>-</span>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div class="mt-3 d-flex" style="gap: 10px;">
        <vs-button v-if="hasFailedItems" color="danger" type="border" @click="$emit('retry-failed')">
          Tentar novamente os que falharam
        </vs-button>
        <vs-button color="primary" @click="$emit('finish')">
          Concluir
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { statusColor, humanStatus, shortError, pendingItemsCount } from '../helpers';

export default {
  name: 'MassCustomerCategoriesProgressPanel',
  props: {
    batch: {
      type: Object,
      required: true,
    },
    isAutoRefreshing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasFailedItems() {
      return (this.batch.failed_tenants || 0) > 0;
    },
  },
  methods: {
    statusColor,
    humanStatus,
    shortError,
    pendingItemsCount,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
